<div class="container fadeIn" *ngIf="eventList && eventList.length > 0">
  <div *ngIf="showTitles" class="row">
    <div class="col-12">
      <h2 class="titleTextFont font-weight-normal text-center" style="font-size: 2.4rem;"
        [ngStyle]="{'color':titlesColor?titlesColor:''}">
        {{ title }}
      </h2>
    </div>
    <div *ngIf="subtitle" class="col-12">
      <h2 class="font-weight-normal fadeIn text-center mb-3 subtitle-block" style="font-size: 1.5rem;"
        [ngStyle]="{'color':secondaryColor?secondaryColor:''}">
        {{ subtitle }}
      </h2>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6 col-lg-4 event-card animate__animated animate__fadeIn mb-5" *ngFor="let event of eventList">
      <div class="card">
        <div class="card-header">
          <div class="business">
            <img class="business--image" [src]="event.businessImage" alt="Business image" loading="lazy"
              decoding="async" />
            <div class="business--name font-weight-bold">
              {{ event.businessName }}
            </div>
          </div>
        </div>
        <img alt="Event image" [src]="event.heroImage"
          sizes="(max-width: 768px) 100vw, (max-width:992px) 50vw, 33vw" class="card-img" decoding="async"
          loading="lazy" />
        <div class="card-body">
          <div class="event-card__date">
            <span class="h5">{{ event.dateNumber }}</span>
            <br />
            <span class="text-danger text-capitalize font-weight-bold">{{
              event.month
              }}</span>
          </div>
          <p class="event-card__schedule">
            Horario: {{ event.startTime }} -
            {{ event.endTime }}
          </p>
          <p class="card-text font-weight-bold">{{ event.title }}</p>
        </div>
        <div class="card-footer">
          <div class="row">
            <div class="col-6 mr-auto" *ngIf="event.price">
              <p class="text-start text-info font-weight-bold h5">
                {{ event.price }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="buttonText" class="col-md-10 offset-md-1 text-center">
    <button class="btn btn-info mt-0 mb-5" tabindex="0">{{buttonText}}</button>
  </div>
  <div class="row" *ngIf="btn1Active || btn2Active" [ngClass]="{
    'align-left': btn1Align === 'left' ,
    'align-center': btn1Align === 'center' ,
    'align-right': btn1Align === 'right'
  }">
    <a *ngIf="btn1Active" [href]="btn1Link"
      class="btn btn-info btn-flex m-2 col-auto">
      {{ btn1Es }}
      <i class="fa fa-arrow-right mx-2"></i>

    </a>
    <a *ngIf="btn2Active" [href]="btn2Link"
      class="btn btn-info-2 btn-flex col-auto">
      {{ btn2Es }}
      <i class="fa fa-arrow-right mx-2"></i>

    </a>
  </div>
</div>
